import { useCallback } from 'react';
// eslint-disable-next-line import/extensions
import { useSwiper } from 'swiper/react';
import c from 'classnames';
import styles from './styles.scss';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// eslint-disable-next-line import/extensions
import 'swiper/css';
import PropTypes from 'prop-types';

const propTypes = {
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(['left', 'right']),
};

const DateTimeCarouselButton = ({ disabled, direction }) => {
  const swiper = useSwiper();
  const currentClassName = c(styles.wrapper, {
    [styles.disabled]: disabled,
    [styles.right]: direction === 'right',
  });

  const handleClick = useCallback(() => {
    if (direction === 'right') {
      return !swiper.isEnd && swiper.slideNext();
    }
    return !swiper.isBeginning && swiper.slidePrev();
  }, [direction, swiper]);

  return (
    <div className={currentClassName} onClick={handleClick}>
      {direction === 'left' ? <ArrowBackIosIcon className={styles.icon} /> : <ArrowForwardIosIcon className={styles.icon} />}
    </div>
  );
};

DateTimeCarouselButton.propTypes = propTypes;

export default DateTimeCarouselButton;
